<template>
  <div class="page page-add">
    <div class="page-container">
      <div class="panel-info">
        <h2 :title="record.title" class="text-ellipsis text-no-wrap overflow-hidden text-bold text-center">{{ record.title }}</h2>
        <div class="flex items-center justify-center">
          <span>发布时间：{{ record.publishTime }}</span>
          <span class="v-ml-md" v-if="record.roles">
            通知范围：
            <a-tag color="purple" v-for="item in record.roles.split(',')" :key="item">
              <template v-if="item == 'U01'">合作项目申请人</template>
              <template v-else-if="item == 'U02'">螺蛳壳改造施工方</template>
              <template v-else-if="item == 'U03'">山区学校</template>
              <template v-else-if="item == 'U04'">山区学校合作伙伴</template>
              <template v-else-if="item == 'U05'">螺蛳壳改造评审专家</template>
              <template v-else-if="item == 'U06'">精灵书屋评审专家</template>
            </a-tag>
          </span>
        </div>
        <a-divider />
        <div class="v-px-lg w1200">
          <editor disabled :options="{ inline: true, hidden_input: false }" v-model="record.content" />

          <div class="v-mt-md" v-if="record.files">
            <div>附件 ( {{ record.files.length }} )：</div>
            <div class="file-list">
              <div class="file-item nowrap text-italic" v-for="file in record.files" :key="file.fileId">
                <img class="file-img" src="~@/assets/images/file_word.svg" v-if="['doc', 'docx'].includes(file.fileFormat)" />
                <img class="file-img" src="~@/assets/images/file_img.svg" v-else-if="['jpg', 'jpeg', 'png', 'gif'].includes(file.fileFormat)" />
                <img class="file-img" src="~@/assets/images/file_excel.svg" v-else-if="['xls', 'xlsx'].includes(file.fileFormat)" />
                <img class="file-img" src="~@/assets/images/file_ppt.svg" v-else-if="['ppt', 'pptx'].includes(file.fileFormat)" />
                <img class="file-img" src="~@/assets/images/file_compress.svg" v-else-if="['rar', 'zip', 'tar', '7z'].includes(file.fileFormat)" />
                <img class="file-img" src="~@/assets/images/file_txt.svg" v-else-if="file.fileFormat === 'txt'" />
                <img class="file-img" src="~@/assets/images/file_pdf.svg" v-else-if="file.fileFormat === 'pdf'" />
                <img class="file-img" src="~@/assets/images/file_video.svg" v-else-if="file.fileFormat === 'video'" />
                <img class="file-img" src="~@/assets/images/file_default.svg" v-else />
                <span class="text-indigo hover-line overflow-hidden ellipsis" :title="file.fileOriginName" @click="downloadFile({ fileId: file.fileId, belongId: record.noticeId, fileSign: 'NOTICE', fileName: file.fileOriginName })">{{ $utils.truncateFileName(file.fileOriginName, 40) }}</span>
              </div>
            </div>
          </div>
        </div>

        <a-affix :offset-bottom="10" :target="() => this.$refs.container">
          <div class="text-center v-mt-sm">
            <a-space>
              <a-button icon="left" @click="$router.go(-1)">返回</a-button>
            </a-space>
          </div>
        </a-affix>
      </div>
    </div>
  </div>
</template>

<script>
import { saveNotice, getNotice } from '@/api/system/notice'
import Editor from './editor'
const form = {
  publishTime: undefined,
  roles: ['U01', 'U02', 'U03', 'U04', 'U05', 'U06'],
  title: '',
  content: '',
}

export default {
  components: {
    Editor,
  },
  data() {
    return {
      noticeId: undefined,
      form: {
        ...form,
        publishTime: this.$moment().format('YYYY-MM-DD'),
      },
      record: {},
      files: [],
    }
  },
  computed: {
    userRoles: vm => vm.$store.state.app.userRoles,
  },
  methods: {
    init() {
      let { id } = this.$route.query
      if (id) {
        this.noticeId = +id
        this.loadNotice()
      }
    },
    loadNotice() {
      getNotice(this.noticeId).then(({ data }) => {
        if (data.success) {
          let { files } = data.result
          this.record = data.result
          this.files = files.map(file => ({
            uid: file.fileId,
            name: file.fileOriginName,
            status: 'done',
            fileSign: 'NOTICE',
            belongId: file.noticeId,
            ...file,
            url: `${this.baseURL}/file/view?id=${file.fileId}&belongId=${file.noticeId}&fileSign=NOTICE`,
          }))
        }
      })
    },
    handleUploadChange(info) {
      this.files = this.handleUploadFile(info, -1)
    },
    handleConfirm(nextStep) {
      let { publishTime, title } = this.form
      // let { expertList, voteList } = this
      this.$message.destroy()
      if (title.trim() === '') {
        this.$message.warning('请输入通知标题')
        this.$refs.title.focus()
        return
      }
      if (!publishTime) {
        this.$message.warning('请选择发布时间')
        this.$refs.publishTime.focus()
        return
      }
      this.$confirm({
        title: nextStep ? '确认保存并发布通知？' : '确认保存通知草稿？',
        centered: true,
        onOk: () => {
          this.handleSubmit(nextStep)
        },
      })
    },
    handleSubmit(nextStep) {
      this.$message.destroy()
      let { title, publishTime, content, roles } = this.form
      let { noticeId, files, fileMark } = this
      let params = {
        noticeId,
        title: title.trim(),
        content,
        publishTime,
        roles: roles.join(','),
        fileIds: files.map(d => d.fileId),
        fileMark,
        nextStep,
      }
      saveNotice(params)
        .then(({ data }) => {
          if (data.success) {
            this.$message.success('操作成功')
            this.noticeId = data.result
            this.$router.go(-1)
          } else {
            this.$message.error('操作失败')
          }
        })
        .catch(() => {
          this.$message.error('操作失败')
        })
    },
  },
  mounted() {
    this.init()
  },
}
</script>
